module.exports = __webpack_public_path__ + "static/img/H.cd7cb60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/H.png
// module id = cEDE
// module chunks = 0